var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "border shadow-md",
    viewBox: "0 0 888.6044444444445 499.84",
    style: {
      width: "888.604px",
      height: "499.84px"
    },
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    x: 0,
    y: 0,
    width: 888.6044444444445,
    height: 499.84,
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 816.4533333333334,
    fill: "#F0A9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 762.0231111111111,
    fill: "#e6a0fd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 707.592888888889,
    fill: "#dc97fb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 653.1626666666667,
    fill: "#d28ef9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 598.7324444444445,
    fill: "#c885f7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 544.3022222222223,
    fill: "#be7cf5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 489.87200000000007,
    fill: "#b473f3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 435.4417777777778,
    fill: "#aa6af1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 381.01155555555556,
    fill: "#a061ef"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 326.58133333333336,
    fill: "#9658ed"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 272.15111111111116,
    fill: "#8c4feb"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 217.7208888888889,
    fill: "#8246e9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 163.29066666666668,
    fill: "#783de7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 108.86044444444445,
    fill: "#6e34e5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.30222222222227,
    cy: 249.92,
    r: 54.43022222222223,
    fill: "#642be3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBig);
export default __webpack_public_path__ + "static/media/header-big.412fcc29f2c40ea384318cbbc0471730.svg";
export { ForwardRef as ReactComponent };